import { JSONObject } from '../../types/types';
import { resolveTemplate } from '../json/resolveTemplate';
import { ResponseActionHandler } from '../../types/context';
import { debugLogger } from '../../debug/DebugLogger';

const log = debugLogger.scope('responseActions');

export const runResponseActions = async (
  responseActions: Record<string, unknown> | undefined,
  responseData: JSONObject,
  getHandler: (name: string) => ResponseActionHandler | undefined
): Promise<void> => {
  if (!responseActions) return;

  const resolved = await resolveTemplate(responseActions, responseData);
  const entries = Object.entries(resolved as Record<string, unknown>);

  const tasks: { name: string; promise: Promise<unknown> }[] = [];
  entries.forEach(([name, params]) => {
    if (params === null || params === undefined) {
      /** @debugFeature responseActions Logs a response action skipped because its params resolved to null/undefined — the action is defined but does not run. */
      log('response action skipped, null params', () => ({ name }));
      return;
    }

    const handler = getHandler(name);
    if (!handler) {
      console.warn(`No response action handler registered for "${name}"`);
      return;
    }

    /** @debugFeature responseActions Logs an executed response action: its name and the resolved params the handler receives. */
    log('response action executed', () => ({ name, params }));

    tasks.push({ name, promise: Promise.resolve(handler(params)) });
  });

  const results = await Promise.allSettled(tasks.map((t) => t.promise));

  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.warn(
        `Response action "${tasks[index].name}" threw`,
        result.reason
      );
    }
  });
};
